import React from "react";

const Insights = () => {
  return <div>Insights Content</div>;
};

export default Insights;
